import { PreviewRendition } from "@/components-v2/FilePreview";
import { isExtensionOffice } from "@/utils/files";
import { ArchiveDocumentType } from "./commonArchiveDomain";

export const PREVIEW_RENDITION_POLL_INTERVAL_MS = 2_000;

type PreviewableEntry = {
  type: ArchiveDocumentType;
  name: string;
  linkTargetType?: ArchiveDocumentType;
};

export const hasPreviewRendition = (entry: PreviewableEntry): boolean =>
  entry.type === ArchiveDocumentType.FILE &&
  entry.linkTargetType === undefined &&
  isExtensionOffice(entry.name) === true;

export const initialPreviewRendition = (entry: PreviewableEntry): PreviewRendition | undefined =>
  hasPreviewRendition(entry) ? { status: "GENERATING" } : undefined;
